import { Global, css } from '@emotion/react'
import { font, color, size, space, screen } from '../styles'
import { padding } from './size'

// -------------
// GLOBAL STYLES
// -------------
const styles = css`
   /* Font sizes vars ... used by (./size.ts) file */
   :root {
      /*-------------*/
      /* Font sizes */
      /*-------------*/
      font-size: 16px;
      font-family: 'Circular Std', Helvetica, Arial, sans-serif;

      --fs-xxl: 36px;
      --fs-xl: 32px;
      --fs-l: 24px;
      --fs-m: 17px;
      --fs-s: 15px;
      --fs-xs: 13px;

      @media screen and (max-width: 395px) {
         --fs-xxl: 32px;
         --fs-xl: 28px;
         --fs-l: 20px;
         --fs-m: 16px;
         --fs-s: 14px;
         --fs-xs: 12px;
      }

      /*-----------*/
      /* Max Width */
      /*-----------*/
      --max-width-profile-pages: 1200px;
      --max-width-main-section: 500px;
      --max-width-illustration-section: 600px;
      --max-width-onboarding-form: 530px;

      /*---------*/
      /* Padding */
      /*---------*/
      --padding-inline: 2em;
      --padding-block: 2em;

      ${screen.onlyTablet} {
         --padding-inline: 1.5em;
         --padding-block: 1.5em;
      }

      ${screen.onlyMobile} {
         --padding-inline: 1em;
         --padding-block: 1.5em;
      }
   }

   body {
      margin: 0;
      padding: 0;
      width: 100vw;
      overflow-x: hidden !important;
      overflow-y: auto !important;

      /* Prevent body scroll when dialog is open */
      :has(dialog[open]) {
         overflow: hidden !important;
      }
   }

   h1,
   h2,
   h3,
   h4 {
      ${font.bold};
      color: ${color.violet};
      margin-block: 0.5em;
   }

   h1 {
      font-size: ${size.xxl};
      line-height: 1.2;
   }
   h2 {
      font-size: ${size.xl};
   }
   h3 {
      font-size: ${size.l};
   }

   h4 {
      font-size: ${size.m};
   }

   h5 {
      font-size: ${size.s};
   }

   p,
   span,
   address {
      ${font.thin};
      font-size: ${size.s};
      color: ${color.grayDark};
   }

   p {
      margin-block: 0.7em;
   }

   a {
      font-size: 1em;
      color: ${color.blue};

      text-decoration: none;

      &:hover {
         text-decoration: underline;
      }

      &:visited {
         color: ${color.violet};
      }
   }

   i,
   .italic {
      ${font.thinItalic};
   }
   b,
   .bold {
      ${font.bold};
   }
   .light {
      ${font.thin};
   }
   .regular {
      ${font.regular};
   }

   .violet {
      color: ${color.violet};
   }
   .green {
      color: ${color.green};
   }
   .blue {
      color: ${color.blue};
   }
   .red {
      color: ${color.red};
   }
   .yellow {
      color: ${color.yellow};
   }
   .orange {
      color: ${color.orange};
   }
   .gray-dark {
      color: ${color.grayDark};
   }
   .gray-light {
      color: ${color.grayLight};
   }

   .main-description {
      font-size: ${size.m};
      color: ${color.grayDark};
      margin-top: 0.2em;
      margin-bottom: 1em;
      line-height: 1.2;
   }

   .gray {
      color: ${color.grayLight};
   }

   /* TODO: check that!!  */
   hr {
      margin-block: ${space.s};
      color: ${color.grayLight};
      width: 100%;
      opacity: 0.5;
   }

   svg.svg-icon {
      width: 1.2em;
      fill: inherit;
      pointer-events: none;
   }

   div.gray-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #f9f9f9;
      padding: ${padding.block} ${padding.inline};
      border-radius: ${space.s};
   }

   .box {
      background-color: #f3f3f3;
      padding: ${padding.block} ${padding.inline};
      border-radius: ${space.s};
      overflow: hidden;
   }

   .formik-field-container {
      width: 100%;

      &.highlighted {
         background-color: #fafafa !important;
         padding: 0.5em 0.8em 0.5em 0.8em;
         box-sizing: border-box;
         border-radius: ${space.m};
         border: 1px solid #f0f0f0;

         .MuiFormControl-root {
            background-color: #fafafa !important;
         }

         label {
            background-color: #fafafa !important;
         }
      }
   }

   /* Select customization field for MUI */
   .sub-group-header {
      color: ${color.black} !important;
      font-size: 1em !important;
      font-family: 'Circular Std Medium', Helvetica, Arial, sans-serif !important;
      border-top: 1px solid #ededed;
      margin-block: 0.4em 0.3em !important;

      &:nth-child(1) {
         border-top: none;
      }
   }
   .sub-group-item {
      padding-left: 2em !important;
   }

   /* Responsiveness Classes */
   .desktop-and-tablet {
      ${screen.showOnDesktopAndTablet};
   }
   .tablet-and-mobile {
      ${screen.showOnTabletAndMobile};
   }

   .desktop {
      ${screen.showOnDesktopOnly};
   }

   .tablet {
      ${screen.showOnTabletOnly};
   }

   .mobile {
      ${screen.showOnMobileOnly};
   }
`

const GlobalStyles = () => <Global {...styles} />
export default GlobalStyles
